import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndpointService } from '@app/core';
import {
  Microproceso,
  TramiteBasico,
} from '@app/shared';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ManageSecondaryCompletionsDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta un tramite por default.
   *
   * @param {number} idTramite
   * @returns {Promise<TramiteBasico>}
   * @memberof ManageSecondaryCompletionsDataService
   */
  getDefaultTramite(idTramite: number): Promise<TramiteBasico> {
    return new Promise((resolve, reject) => {
      this.http.get<TramiteBasico>(this.api.get('tramiteTasks', [idTramite])).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  /**
   * Consulta un microproceso por default.
   *
   * @param {number} idTask
   * @returns {Promise<Microproceso>}
   * @memberof ManageSecondaryCompletionsDataService
   */
  getDefaultMicroProces(idTask: number): Promise<Microproceso> {
    return new Promise((resolve, reject) => {
      this.http.get<Microproceso>(this.api.get('microprocessTasks', [idTask])).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-secondary-completions/shared/manage-secondary-completions.data.service.ts